export default __webpack_public_path__ + "static/user1-1dcaf5d3ac1a3150abe9a0b0c23adbb0.webp";